import React from "react";
import { getValue } from "@utils/lodash";

function MoreReportSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 23"
      >
        <defs>
          <clipPath id="clip-path7">
            <rect
              id="Rectangle_18187"
              data-name="Rectangle 18187"
              width="24"
              height="23"
              transform="translate(-14637 -8280)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_295"
          data-name="Mask Group 295"
          transform="translate(14637 8280)"
          clipPath="url(#clip-path7)"
        >
          <path
            id="insert_chart_FILL0_wght300_GRAD0_opsz24"
            d="M8.828-13.706h1.588v-6.882H8.828Zm4.113,0h1.588V-23.765H12.941Zm4.113,0h1.588v-3.706H17.054ZM6.649-9.735a1.848,1.848,0,0,1-1.358-.556,1.848,1.848,0,0,1-.556-1.358V-25.821a1.848,1.848,0,0,1,.556-1.358,1.848,1.848,0,0,1,1.358-.556H20.821a1.848,1.848,0,0,1,1.358.556,1.848,1.848,0,0,1,.556,1.358v14.172a1.848,1.848,0,0,1-.556,1.358,1.848,1.848,0,0,1-1.358.556Zm0-1.588H20.821a.311.311,0,0,0,.224-.1.311.311,0,0,0,.1-.224V-25.821a.311.311,0,0,0-.1-.224.311.311,0,0,0-.224-.1H6.649a.311.311,0,0,0-.224.1.311.311,0,0,0-.1.224v14.172a.311.311,0,0,0,.1.224.311.311,0,0,0,.224.1ZM6.324-26.147v0Z"
            transform="translate(-14638.735 -8249.765)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default MoreReportSvgComponent;
